export const couponCenter = {
  receive: '6465.0', // 领取优惠卷点击
  use: '6467.0', // 去使用点击
  bannerExposure: '8697.0', // 广告位曝光
  bannerClick: '8697.0', // 广告位点击
  couponExposure: '9622.0', // 优惠卷曝光
  goPop: '9623.0', // 店铺名点击进入店铺
  adCouponClick: '10428.0', // 广告位优惠券点击
  couponPackGoList: '10433.0', // 省钱券包-查看全部点击
  couponPackGoDetail: '10434.0', // 省钱券包-去抢购点击
  goRechard: '10430.0', // 美菜充值卡固定位点击
  tabClick: '10431.0', // 优惠券分类点击
  classTabClick: '10440.0' // 多品类券-一级分类点击
}
